<template>
    <div class="html-viewer">
        <iframe
            ref="iframeEl"
            sandbox="allow-scripts"
            class="html-viewer-iframe"
        />
    </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, watch } from "vue";

import {
    buildHtmlSrcdoc,
    createHeightMessageHandler,
    getDocumentCSSVars,
} from "@/lib/html-preview";

const props = defineProps<{ content: string }>();

const iframeEl = ref<HTMLIFrameElement>();
let cleanup: (() => void) | undefined;

const render = (content: string) => {
    const el = iframeEl.value;
    if (!el) return;
    cleanup?.();
    el.srcdoc = buildHtmlSrcdoc(content, getDocumentCSSVars());
    cleanup = createHeightMessageHandler(el, (height) => {
        el.style.height = `${height}px`;
    });
};

onMounted(() => render(props.content));
watch(() => props.content, render);

onUnmounted(() => cleanup?.());
</script>

<style scoped lang="scss">
.html-viewer {
    width: 100%;
}

.html-viewer-iframe {
    display: block;
    width: 100%;
    height: 0;
    border: none;
}
</style>
